import React from "react";
import Icon from '../../ui/icon/icon';
import { TicketCard } from "../ticketCard/ticketCard";


export function NewHolderEmail({description}) {
    if (!description) {
        return null;
    }

    return (
        <div className='neo-item-card-new-holder-email-container'>
            <span><Icon name='paperPlane'/></span>
            <span>
                {description}
            </span>
        </div>
    )
}

export default function TicketTransferCard({config, onSubmit = () => {}, withMargin}) {

    const transferStatus = React.useMemo(() => {
        switch (config.transfer_status) {
        case "validated":
        case "pending":
            return "secondary";
        default:
            return "default";
        }
    }, [config]);

    return <TicketCard ticket={config.ticket_transfer_card || config} onSubmit={onSubmit} cardStatus={transferStatus} withMargin={withMargin} content={<NewHolderEmail description={config.transfer_description}/>}/>
}
